module.exports = __webpack_public_path__ + "static/media/ico-sdsm.759f216e.svg";